import {
  CheckboxComponent,
  PaperComponent,
  SecureDataComponent,
  TextFieldComponent,
  SnackbarComponent,
} from "@/components";
import { CKYC_SCHEMA, PAN_SCHEMA, WEB_COLORS } from "@/lib/constants";
import { useRouter } from "@/i18n/routing";
import { useFooter } from "@/lib/context/FooterContext";
import {
  useGetCustomerQuery,
  useGetPanDetailsQuery,
  useVerifyPanDetailsMutation,
  useCreditScoreDashboardDataLatestMutation,
  useCreditDashboardDataLastQuery,
} from "@/lib/redux";
import {
  FormHelperText,
  Grid,
  Stack,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import useLogoutHook from "@/lib/hooks/logoutHook";
import { useFormik } from "formik";
import { useTranslations } from "next-intl";
import React, { useCallback, useEffect, useState } from "react";
import { IMAGES } from "@/lib/constants";
import HeroLoaderComponent from "@/components/HeroLoader";
import ErrorModal from "../ErrorModal";

const PanDetails = ({panProfileReady}) => {
  const theme = useTheme();
  const t = useTranslations("IdentityDetails");
  const dText = useTranslations("creditScore");
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  //   const [showPanDetails, setShowPanDetails] = useState(false);
  const { handleLogout } = useLogoutHook();
  const { setActions } = useFooter();
  const [loading, setLoading] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false)
  const [errorMessage, setErrorMessage] = useState("");
   const [agreeFetchCreditScore, setAgreeFetchCreditScore] = useState(true)
  const [agreeFinancialOffers, setAgreeFinancialOffers] = useState(true)
   const router = useRouter();
    //const router = useRouter();
   const credit_emailRegex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
   //const [panDetails, setPanDetails] = useState();

  const imgSrc = IMAGES.crifLogo;

  //API HOOKS
  const {
    data: customerData,
    isLoading: fetchingCustomerData,
    isError: isErrorCustomer,
    error:isGetErrorCustomer,
  } = useGetCustomerQuery();

  const {
    data: panDetails,
    isLoading: panDetailsLoading,
    isError: panDetailsErrors,
    error:panDetailsError
  } = useGetPanDetailsQuery();

  const [
  verifyPan,
  {
    data: verifyPanData,
    isLoading: verifyPanLoading,
    isError: verifyPanErrors,
    error: verifyPanError
  },
] = useVerifyPanDetailsMutation();

  const [
    fetchCreditScore,
    {
      data: fetchCreditScoreLatestData,
      isLoading: isLoadingFetchCreditScoreLatest,
      isError: errorFetchCreditScoreLatest,    
      error:fetchCreditCardLatestDataError
    },
  ] = useCreditScoreDashboardDataLatestMutation();

  /****ERROR HANDLING****/
  const isError =
    // isGetErrorCustomer ||
    verifyPanError ||
    panDetailsError ||
    fetchCreditCardLatestDataError;

  /******EFFECT METHODS******/  
  //useErrorHandling(isError, handleLogout);

  //Pan 
  const formik = useFormik({
    validationSchema: PAN_SCHEMA,
    enableReinitialize: true,
    initialValues: {
      pan: panDetails?.data?.panDetails?.pan || "",
      consent: false,
      panType: "individual",
    },
    onSubmit: (values) => {
      //setLoading(true);
      const body = {
        consent: values?.consent === true,
        pan: values?.pan?.toUpperCase(),
      };
      verifyPan(body);
      //handleCheckErrorMsg();
    },
  });

  //Pan Details with Email
  const verifyPanFormik = useFormik({
    enableReinitialize: true,
   // validationSchema: CKYC_SCHEMA,
    initialValues: {
      firstName:
        panDetails?.data?.panDetails?.firstName ||
        verifyPanData?.data?.panDetails?.firstName ||
        "",
      lastName:
        panDetails?.data?.panDetails?.lastName ||
        verifyPanData?.data?.panDetails?.lastName ||
        "",
      pan:
        panDetails?.data?.panDetails?.pan ||
        verifyPanData?.data?.panDetails?.pan ||
        "",
      dob:
        panDetails?.data?.panDetails?.dob ||
        verifyPanData?.data?.panDetails?.dob ||
        "",
      dob:
        panDetails?.data?.panDetails?.gender ||
        verifyPanData?.data?.panDetails?.gender ||
        "",
      agreeCreditFetchScore: true,
      agreeFinancialOffers: 
        panDetails?.data?.panDetails?.agreeFinancialOffers ||
        verifyPanData?.data?.panDetails?.agreeFinancialOffers ||
        agreeFinancialOffers,
    },
    validate: values => {
    // const errors = {};
    // if (!values.email) {
    //   errors.email = "Email is required";
    // } else if (!credit_emailRegex.test(values.email)) {
    //   errors.email = "Enter a valid email";
    // }
    // return errors;
  },
    onSubmit: (values) => {
      setLoading(true)
      // const requestData ={
      //   pan: values?.pan,
      //   consentCreditBureau: true,
      //   consentFinancialOffer: values?.agreeFinancialOffers,
      // };
      // fetchCreditScore(requestData);
      router.replace(`/check-eligibility/check-eligibility-dashboard`); 
    },
  });
 
  const handleFieldChange = (e) => {
    // Only allow uppercase letters and digits
    const rawValue = e.target.value.toUpperCase();
    const filteredValue = rawValue.replace(/[^A-Z0-9]/g, "");
    e.target.value = filteredValue;
    formik.handleChange(e);
  };

  const onGoBackPressModal = () => {
    setShowErrorModal(false)
  }
  // Effect Methods
  useEffect(() => {
    let isPanVerified = verifyPanData?.data?.panDetailFound;
    if(panDetails?.data?.panDetailFound || verifyPanData?.data?.panDetailFound){
      isPanVerified = true;
    }else{
      isPanVerified = false;
    }
    setActions({
      onConfirm: 
        !isPanVerified
        ? () => formik.handleSubmit()
        : () => verifyPanFormik.handleSubmit(),
      confirmBtnLabel:
        panDetails?.data?.panDetailFound || verifyPanData?.data?.panDetailFound
          ? t("proceed")
          : t("verifynow"),
      showReject: true,
      disabledConfirmBtn: !isPanVerified
        ? (!formik?.values?.pan || !formik?.values?.consent) 
        : ""//!verifyPanFormik?.values?.email //!(verifyPanFormik.dirty && verifyPanFormik.isValid && verifyPanFormik?.values?.email)
    });
  }, [
    setActions,
    panDetails,
    verifyPanData,
    formik?.values?.pan,
    formik?.values?.consent,
  ]);

  //Error handling
  const handleCreditError = useCallback(() => {
    if (!isError) return;
      if (isError) {
      setLoading(false);
      if (
        (isError?.name === "TypeError" &&
          isError?.message?.includes("NetworkError")) ||
        isError.status === "FETCH_ERROR"
      ) {
        SnackbarComponent({
          error: true,
          errorMessage:
            "Network error. Please check your connection and try again.",
        });
        return;
      }
      const status = isError?.status;
      if (status === 401) {
        SnackbarComponent({
          error: isError,
          errorMessage: "Your session has expired. Please login again",
        });
        handleLogout();
      } else if (status === 500) {
        SnackbarComponent({
          error: isError,
          errorMessage:
            isError?.data?.detail || isError?.data?.message ||
            "Something went wrong. Please try again later.",
        });  
      }else if (status > 500) {
        SnackbarComponent({
          error: isError,
          errorMessage:
            isError?.data?.detail || isError?.data?.message ||
            "Something went wrong. Please try again later.",
        });  
      }else if (status >= 400 && status < 500) {
        SnackbarComponent({
          error: isError,
          errorMessage:
             isError?.data?.detail || isError?.data?.message || "Request error. Please check your input.",
        });
      }
      else if (status == 504) {
        SnackbarComponent({
          error: isError,
          errorMessage:
             isError?.data?.detail || "Network Error, Please check your network.",
        }); 
        return;
      }
    }
  }, [isError, handleLogout]);
 
  useEffect(() => {
    handleCreditError();
  }, [isError]);

  // useEffect(() => {
  //   if (fetchCreditScoreLatestData) {
  //     //setLoading(false);  
  //     router.replace(`/check-eligibility/check-eligibility-dashboard`); 
  //   }
  // }, [fetchCreditScoreLatestData]);

 useEffect(() => {
  if (!isError) return;
  if (isError) {
    setLoading(false);
    const msg =
      isError?.data?.message || 
      isError?.data?.detail ||
      "Something went wrong. Please try again later.";
    setErrorMessage(msg);
    setShowErrorModal(true)
  }      
}, [isError]);

  return (
   <Stack
        m={{ xs: 1 }}
        px={2}
        gap={2}
        flexGrow={1}
        direction={"column"}
        alignItems={"center"}
        justifyContent={"center"}
      >
  {loading ? (
    <HeroLoaderComponent
      open={true}
      loadingLabel={dText("pleasewait")}
      poweredBy={dText("poweredby")}
      imgSrc={imgSrc}
    />
   ) : (
    <>
    <PaperComponent
      noDrop
      paperStyle={{
        backgroundColor: "#F2F7F799",
        border: "1px solid #F0F0F099",
      }}
      sx={{
        backgroundColor: { xs: "#fff", md: "#F2F7F799" },
        border: { xs: "none", md: "1px solid #F0F0F099" },
        padding: {xs:"0px", md:"20px"},
        borderRadius: { xs: 0, md: 2 }
      }}
    >
      {!panDetails?.data?.panDetailFound &&
        !verifyPanData?.data?.panDetailFound && (
        <Stack gap={2}>
          <Typography
            color={WEB_COLORS.primary}
            fontSize={{ xs: "0.9rem", sm: "1.3rem", md: "1.3rem" }}
            fontWeight={{xs:400, sm:700, md:700}}
            sx={{
              backgroundColor:{xs:"#F2F7F799", sm:"transparent", md:"transparent"},
              padding:{xs:"10px 10px 10px 20px", sm:"0px", md:"0px"},
              marginLeft:{xs:"-20px", sm:"0px", md:"0px"},
            }}
          >
            We need few additional detail to check your eligibility
          </Typography>
          <Typography>
            To proceed, please share your PAN number 
          </Typography>
          <Grid container spacing={2} rowSpacing={1} my={2}>
            <Grid item xs={12} sm={12} md={12}>
              <TextFieldComponent
                disabled={
                  panDetails?.data?.panDetailFound ||
                  verifyPanData?.data?.panDetailFound
                }
                required
                inputPropsStyle={{ textTransform: "uppercase" }}
                name="pan"
                maxLength={10}
                label={t("pannumber")}
                value={formik.values.pan}
                placeholder={t("pannumber")}
                errorMessage={formik?.errors?.pan || verifyPanError?.data?.detail}
                error={
                  Boolean(formik.touched.pan && formik?.errors?.pan) ||
                  Boolean(verifyPanError)
                }
                onBlur={formik.handleBlur}
                onChange={(e) => {
                  handleFieldChange(e);

                  const panValue = e.target.value?.toUpperCase();
                  const panRegex = /^([A-Z]){5}([0-9]){4}([A-Z]){1}$/;
                }}
              />
            </Grid>
          </Grid>
          </Stack>
      )}

      {!panDetails?.data?.panDetailFound &&
        !verifyPanData?.data?.panDetailFound && (
          <Stack gap={2} 
            sx={{
              position:{xs:"absolute", sm:"inherit", md:"inherit"},
              bottom:{xs:"140px", sm:"", md:""}
            }}
          >
            <CheckboxComponent
              onChange={(e) => {
                formik.setFieldValue("consent", e.target.checked);
              }}
              checked={formik?.values?.consent}
              name="consent"
              label={
                <Typography
                  fontSize={isMobile ? "0.7rem" : "0.8rem"}
                  color={WEB_COLORS.disabledColor}
                >
                  {t("cersai")}
                </Typography>
              }
            />
            {formik?.errors?.consent && formik.submitCount > 0 && (
              <FormHelperText sx={{ color: "#d32f2f" }}>
                {formik?.errors?.consent}
              </FormHelperText>
            )}
          </Stack>
        )}

      {(panDetails?.data?.panDetailFound ||
        verifyPanData?.data?.panDetailFound) && (
        <Typography mt={3} mb={2} 
         sx={{
            fontSize: { xs: "0.9rem", sm:"1.1rem", md: "1.1rem"},
          }}>
          {t("verifydetails")}
        </Typography>
      )}

      <Grid container my={2} spacing={2}>
        {(panDetails?.data?.panDetails?.firstName ||
          verifyPanData?.data?.panDetails?.firstName) && (
          <Grid item xs={12}>
            <TextFieldComponent
              allowCapitalization={true}
              disabled
              name="firstname"
              label={t("firstname")}
              value={verifyPanFormik.values.firstName}
            />
          </Grid>
        )}
        {(panDetails?.data?.panDetails?.lastName ||
          verifyPanData?.data?.panDetails?.lastName) && (
          <Grid item xs={12}>
            <TextFieldComponent
              allowCapitalization={true}
              disabled
              name="lastname"
              label={t("lastname")}
              value={verifyPanFormik.values.lastName}
              
            />
          </Grid>
        )}
        {(panDetails?.data?.panDetails?.dob ||
          verifyPanData?.data?.panDetails?.dob) && (
          <Grid item xs={12}>
            <TextFieldComponent
              disabled
              name="dob"
              label={t("dob")}
              value={verifyPanFormik.values.dob}
            />
          </Grid>
        )}
        {(panDetails?.data?.panDetails?.dob ||
          verifyPanData?.data?.panDetails?.dob) && (
          <Grid item xs={12}>
            <TextFieldComponent
              disabled
              name="gender"
              label={t("gender")}
              value={verifyPanFormik.values.gender}
            />
          </Grid>
        )}

        {(panDetails?.data?.panDetailFound ||
        verifyPanData?.data?.panDetailFound) && (

          <Grid item xs={12} sm={12} md={12}>
               <Stack gap={2}>
                 <Typography
                  fontSize={isMobile ? "0.7rem" : "0.8rem"}
                  color={WEB_COLORS.disabledColor}
                >
                  The information shown has been fetched based on your PAN. By proceeding,
           you confirm that the details are correct to the best of your knowledge and consent 
           to continue with the loan application journey
                </Typography>
                <a
                className="doc-link"
                href=""
                rel=""
                p={{ xs: 3, sm: 6 }}
              >
                This is not my information
              </a>
          
          </Stack>
          <Stack gap={2}>
             <CheckboxComponent
              checked={agreeFinancialOffers}
              name="agreeFinancialOffers"
              onChange={(e) => {
                setAgreeFinancialOffers(e.target.checked);
              }}
              label={
                <Typography
                  fontSize={isMobile ? "0.7rem" : "0.8rem"}
                  color={WEB_COLORS.disabledColor}
                >
                  I authorize Hero FinCorp to fetch my credit information & check my eligibility for loan offers.
                  I understand this information will be used as per the terms of use and privacy policy
                </Typography>
              }
            />
            {verifyPanFormik?.errors?.consent && verifyPanFormik.submitCount > 0 && (
              <FormHelperText sx={{ color: "#d32f2f" }}>
                {verifyPanFormik?.errors?.consent}
              </FormHelperText>
            )}
          </Stack>
          </Grid>
        )}
      </Grid>
    </PaperComponent>
     <ErrorModal visible={showErrorModal} message={errorMessage} onClose={onGoBackPressModal} />
     </>
   )}
    
    </Stack>
  );
};

export default PanDetails;